
export default function ListItem(props: {children: any, isActive?: boolean, className?: string, onClick?: Function}){
    const {children, isActive = false, className = '', onClick} = props ;
    return (
        <div className={`relative group/list w-full flex flex-col h-full  items-center justify-center  border rounded-[10px] cursor-pointer ${className || ''} ${isActive ? 'border-[#14A5FA]' : 'border-[#D9D9D9]'}`}
            onClick={() => onClick && onClick()}>
            {children} 
        </div> 
    )
}